import { render } from "./MyViewOrderRefund.vue?vue&type=template&id=21dcd0a7"
import script from "./MyViewOrderRefund.vue?vue&type=script&lang=js"
export * from "./MyViewOrderRefund.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__